import React from 'react';
import ScrollToTop from 'components/common/ScrollToTop/index';
import './styles.scss';

const Support = () => (
  <ScrollToTop immediate>
    <div data-testid="support">
      <div styleName="support">
        <h2>Support</h2>
        <p>
          If you have questions or need support, please call 1-833-MY-RESET
          (1-833-697-3738)
        </p>
      </div>
      <div styleName="contact">
        <h3>Contact Us</h3>
        <address>
          Pear Therapeutics
          <br />
          201 Mission St. #1450
          <br />
          San Francisco, CA 94105
          <br />
        </address>
      </div>
    </div>
  </ScrollToTop>
);

export default Support;
